// Module
var code = "<ui-v2-embed id=\"bgworker\" src=\"/v2/embed/admin/sensors/\"></ui-v2-embed> ";
// Exports
export default code;